/************
 Filtering
 ************/

// Dropdowns
const dropdowns = Array.from(document.querySelectorAll(".collectionFiltersDropdownItem"));
dropdowns.forEach(element => {
    // add event listener to button
    element.querySelector(".collectionFiltersDropdownItemButton").addEventListener("click", function () {
        dropdowns
            .filter(el => el !== element)
            .forEach(dropdownItem => dropdownItem.classList.remove("open"));
        // toggle dropdown
        element.classList.toggle("open");
    });
});

document.querySelectorAll(".collectionFiltersDialogBodyItem").forEach(dropdownItem => {
    dropdownItem.querySelector(".collectionFiltersDialogBodyItemButton")?.addEventListener("click", function () {
        dropdownItem.classList.toggle("open");
    });
});

// More Filters button
document.querySelector(".collectionFiltersDropdownsMoreFiltersButton").addEventListener("click", function () {
    document.querySelector(".collectionFiltersDropdowns").classList.toggle("showMore");
});

// Dialog
document.querySelector(".collectionFiltersDialogButton").addEventListener("click", function () {
    document.querySelector(".collectionFiltersDialog").showModal();
});

document.querySelector(".collectionFiltersDialogHeaderCloseButton").addEventListener("click", function () {
    document.querySelector(".collectionFiltersDialog").close();
});
